module.exports = "/assets/data/7c0667d98464b1393215d665b5a3b085-B60.data.json";